import styled from "styled-components";
import themes from "@/styles/themes";

const DetailsCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 12px 12px 21px 12px;
  text-align: center;


  h4.offer-value {
    font-size: 34px;
    font-weight: 900;
    color: ${themes.estadao};
    margin: 0 0 16px 0;
  }
  h4.offer-value.anual {
    font-size: 30px;
  }
  h4.offer-value span {
    font-size: 20px;
    font-weight: normal;
  }

  h3.offer-title {
    font-size: 18px;
    font-weight: 900;
    color: ${themes.greyDark};
    margin-bottom: 0px;
    margin-top: 12px;
  }

  p.sm-call-action {
    font-size: 12px;
    font-style: italic;
    color: ${themes.greyDark};
  }

  p.stair-info {
    font-size: 14px;
    margin: 0px;
  }

  p.text-cancel {
    font-size: 12px;
    font-weight: 700;
    font-style: italic;
    color: #2c2c2c;
    margin: 5px 0px 8px 0px;
  }

  p.text-legal, p.text-access {
    font-size: 11px;
    text-align: left;
    color: ${themes.greyNormal};

    .text-summary {
      color:${themes.estadao};
      font-size: 12px;
      font-weight: bold;
      text-decoration: underline;
      text-align: left;
      cursor: pointer;
    }

    a{
      color: ${themes.grey};
      font-weight: 700;
      text-decoration: underline;
    }
    b { 
      font-weight: 700;
    }
  }

  button.show-details {
    border: none;
    background: none;
    font-size: 16px;
  }

  p.change-plan {
    color:${themes.estadao};
    font-size: 16px;
    text-decoration: underline;
    line-height: 1.81;
    text-transform: uppercase;
    margin: 0px;
  }
`

export default DetailsCard